<template>
	<div>
		<errorHeader></errorHeader>
		<div class="title">企业微信扫描登录</div>
		<div class="iframe_box">
			<iframe :src="webLogin" frameborder="0"></iframe>
		</div>
		<copyFooter color="#000"></copyFooter>
	</div>
</template>
<script>
	import errorHeader from '../components/errorHeader.vue'
	import copyFooter from '../components/copyFooter.vue'
	export default {
		data() {
			return {
				webLogin: process.env.VUE_APP_REDIRECT_URI_URL,
			}
		},
		components: {
			copyFooter,
			errorHeader
		},
		methods: {
			black() {
				this.$router.push('/login')
			},

		}
	}
</script>

<style lang="scss" scoped="scoped">
	.title{
		font-size: 24px;
		font-family: PingFang SC;
		font-weight: 600;
		color: #040404;
		display: flex;
		justify-content: center;
		line-height: 72px;
		margin: 55px 0px 57px 0px;
	}
	.copyFooter {
		position: fixed;
		width: 100%;
		line-height: 32px;
		z-index: 4;
		text-align: center;
		bottom: 10px;
		color: #999999;
		font-weight: 300;
	}

	.iframe_box {
		display: flex;
		align-items: center;
		justify-content: center;

		iframe {
			width: 378px;
			height: 441px;
		}
	}
</style>
